import React, { Component } from 'react';
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { Http } from '../../../../support';
import { useStore } from '../../../../store';
import Loading from '../../../../facturotopia/loading/Loading';
import UsuariosBulkDestroyModal from './UsuariosBulkDestroyModal';

class UsuariosItemActions extends Component {
  state = {};

  handleActive = () => {
    this.submit({
      status: 1,
      comentario: 'Solicitud del cliente',
    });
  };

  handleSuspend = () => {
    this.submit({
      status: 0,
      comentario: 'Solicitud del cliente',
    });
  };

  submit = async (reason = {}) => {
    this.setState({ busy: true });

    const { status, comentario } = reason;

    try {
      const { selectedRowKeys } = this.props;

      const params = {
        usuario_ids: selectedRowKeys,
        status,
        comentario,
      };

      const response = await Http.patch(`api/usuarios/status`, params);

      this.setState({ busy: false });

      this.props.listAction.highlight(response.data);
      this.props.onActionComplete({ selectedRowKeys: [], selectedRows: [] });

      window.ToastManager.show({
        variant: 'success',
        title: 'Cambio de status',
        message: 'Actualización de status exitoso',
      });
    } catch (error) {
      const _error = error.data || error;

      this.setState({ busy: false });

      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: _error.message || 'Error recuperando información del usuario',
      });
    }
  };

  handleDestroy = () => this.setState({ deleting: true, selectedRows: this.props.selectedRows });
  handleDestroyClose = () => this.setState({ deleting: false });

  isActive = () => {
    const { selectedRows } = this.props;

    const active = selectedRows.filter((item) => {
      return item.status === 1;
    });

    const suspended = selectedRows.filter((item) => {
      return item.status === 0;
    });

    let isActive = undefined;

    if (active.length > 0 && suspended.length === 0) {
      isActive = true;
    } else if (active.length === 0 && suspended.length > 0) {
      isActive = false;
    }

    return isActive;
  };

  render() {
    if (this.state.busy) {
      return <Loading />;
    }

    if (this.state.deleting) {
      return (
        <UsuariosBulkDestroyModal
          show={this.state.deleting}
          onClose={this.handleDestroyClose}
          selectedRows={this.props.selectedRows}
        />
      );
    }

    let isActive = this.isActive();

    return (
      <Dropdown
        as={ButtonGroup}
        alignRight={true}
      >
        <Dropdown.Toggle
          variant="secondary"
          id="dropdown-basic"
        >
          Acciones{' '}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {isActive === true && (
            <>
              {Guardian.allows('usuario.suspender') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.handleSuspend}
                >
                  Suspender
                </Dropdown.Item>
              )}
            </>
          )}
          {isActive === false && (
            <>
              {Guardian.allows('usuario.activar') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.handleActive}
                >
                  Activar
                </Dropdown.Item>
              )}
            </>
          )}
          {Guardian.allows('usuario.eliminar') && (
            <Dropdown.Item
              as="div"
              onClick={this.handleDestroy}
            >
              Eliminar
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapState = (state) => {
  return { list: state.app.usuarios.list };
};

const mapActions = (actions) => {
  return { listAction: actions.app.usuarios.list };
};

export default connect(useStore, mapState, mapActions)(UsuariosItemActions);
